import { useReferentialModels } from "./referential-models.query";

export const useReferentialModelUtils = () => {
  const { models } = useReferentialModels();

  // TODO DEV-8365 delete `getModelFromClassPath` when fqcn/classPath migration finish
  const getModelFromClassPath = (fqcn: string) => {
    return models.find((model) => model.fqcn === fqcn);
  };

  return {
    getModelFromClassPath,
  };
};
